export default {
  // 默认会话项
  defaultConversations: {
    whatIsIt: '这是什么？',
    howToInstall: '如何快速安装组件？',
    newAGIInterface: '全新 AGI 混合界面',
  },
  
  // 分组标签
  groups: {
    today: '今天',
    previous: '更早',
  },
  
  // 错误消息
  errors: {
    requestInProgress: '请求进行中，请等待完成。',
    requestSuspended: '请求已暂停。',
    requestFailed: '请求失败，请重试！',
    planLimitReached: '您已达到当前套餐的使用上限。',
    upgradeToAccessMore: '立即升级以解锁更多任务，或在明天上午 8:00 后重试。',
    failedToUpdateMessage: '消息更新失败。',
    feedbackSubmitFailed: '反馈提交失败。',
    cannotEditMessage: '无法编辑消息：数据格式不正确或不完整',
  },
  
  // 成功消息
  success: {
    feedbackSubmitted: '反馈已提交。',
    messageUpdated: '消息已更新。',
  },
  
  // 按钮文本
  buttons: {
    upgrade: '升级',
    startYourOwnTask: '开始新任务',
  },
  
  // 提示文本
  tips: {
    viewingTask: '您正在查看一个任务，可以亲自尝试一下！',
    waiting: '等待中...',
  },
  
  // 状态文本
  status: {
    error: '错误',
  },
  
  // 操作提示
  operations: {
    refreshMessageContent: '刷新消息内容',
    editMessage: '编辑消息',
    likeMessage: '点赞消息',
    dislikeMessage: '点踩消息',
    renameSession: '重命名会话',
    deleteSession: '删除会话',
  },
  
  // 弹窗标题
  modalTitles: {
    renameSession: '重命名会话',
    deleteSession: '删除会话',
    feedback: '反馈',
  },
  
  // 输入框占位符
  placeholders: {
    renameSession: '请输入新的会话名称',
    feedbackReason: '请输入反馈原因',
  },
  
  // 确认消息
  confirmations: {
    deleteSession: '确定要删除此会话吗？',
  },
  
  // 加载状态
  loading: {
    loadingSessionMessages: '正在加载会话消息...',
    loading: '加载中...',
  },
  
  // 空状态
  empty: {
    noMessages: '暂无消息',
    noSessions: '暂无会话',
  },
  
  // 时间相关
  time: {
    justNow: '刚刚',
    minutesAgo: '分钟前',
    hoursAgo: '小时前',
    daysAgo: '天前',
  },
  
  // 文件相关
  files: {
    attachments: '附件',
    otherAttachments: '其他附件',
    imageFile: '图片文件',
    documentFile: '文档文件',
  },
  
  // 会话相关
  session: {
    newSession: '新建会话',
    sessionName: '会话名称',
    sessionId: '会话 ID',
    tempSession: '临时会话',
  },
  
  // 消息相关
  message: {
    user: '用户',
    assistant: '助手',
    system: '系统',
    messageId: '消息 ID',
    content: '内容',
    role: '角色',
    status: '状态',
    feedback: '反馈',
    like: '点赞',
    dislike: '点踩',
  },
  
  // 聊天机器人类型
  chatBotTypes: {
    dnaChatbot: 'DNA 聊天机器人',
    agentChatbot: 'Agent 聊天机器人',
    shareChatbot: '分享型聊天机器人',
  },
  
  // 功能工具
  tools: {
    functionTools: '功能工具',
    commandTools: '指令工具',
    action: '操作',
    toolStart: '工具启动',
    toolEnd: '工具结束',
    command: '指令',
    done: '完成',
  },
  
  // 主页面相关
  mainPage: {
    loading: '加载中...',
    noActiveSession: '暂无活跃会话',
    userId: '用户 ID',
    sessionList: '会话列表',
    token: 'Token',
  },
  
  // 聊天机器人配置
  chatBotConfig: {
    chatbot: '聊天机器人',
    dnaChatbot: 'DNA 聊天机器人',
    shareChatbot: '分享型聊天机器人',
  },
  
  // 功能开关
  features: {
    showChatSider: '显示聊天侧边栏',
    showChatWelcome: '显示聊天欢迎语',
    showChatTemplate: '显示聊天模板',
  },
  
  // ChatList 组件
  chatList: {
    refresh: '刷新',
    copy: '复制',
    edit: '编辑',
    like: '点赞',
    dislike: '点踩',
    copiedToClipboard: '已复制到剪贴板。',
    copyFailed: '复制失败，请手动复制',
    copyFailedFallback: '复制失败，请手动复制。',
    welcomeMessage: '你好 {firstName}，我能如何帮你实现营销目标？',
    prompt1: '你能帮我获取 1,000 个新用户吗？',
    prompt2: '你能帮我想一些品牌的病毒式传播创意吗？',
    prompt3: '你能帮我写一篇社交媒体帖子吗？',
    unableToDisplayContent: '无法显示此内容格式。',
    unknownFiles: '未知文件',
    head: 'Aha',
  },
  
  // 编辑器相关
  editor: {
    editPlaceholder: '在此编辑内容...',
  },

  // 输入框相关
  chatSender: {
    errors: {
      fileTooLarge: '文件必须小于 10MB！',
      batchUploadFailed: '批量上传失败。',
      waitUpload: '请等待文件上传完成。',
    },
    messages: {
      fileRemoved: '{name} 已被移除。',
      requestCancelled: '请求已取消。',
    },
    attachments: {
      dropTitle: '将文件拖到此处',
      description: '点击或拖拽文件到这里上传（支持图片、文档及其他格式）',
    },
    titles: {
      image: '图片',
    },
    placeholder: {
      input: '请输入消息...',
    },
  },

  // 侧边栏相关
  chatSider: {
    buttons: {
      startCampaign: '开始活动',
      startTask: '开始任务',
      viralIdeas: '爆款创意',
      headsDna: 'Aha DNA',
    },
    tooltips: {
      ongoingTask: '您有一个进行中的任务，请稍后再开始新任务。',
    },
    labels: {
      taskHistory: '任务历史',
      newConversation: '新建会话 {number}',
    },
    menu: {
      rename: '重命名',
      delete: '删除',
    },
    errors: {
      failedGetSessionId: '获取会话 ID 失败。',
    },
  },

  // Command tool 相关
  commandTool: {
    onboarding: {
      congratulations: '恭喜！您已完成新手引导。',
      continue: '继续',
    },
  },

  // Template 配置
  templateConfig: {
    categories: {
      marketResearch: '市场调研',
      marketingStrategy: '营销策略',
      contentCreation: '内容创作',
      digitalMarketing: '数字营销',
      offlineEvents: '线下活动',
      brandManagement: '品牌管理',
    },
    marketResearch: {
      title: '市场调研',
      items: {
        conductResearch: '开展市场调研',
        assessCompetitive: '评估竞争格局',
        monitorSentiment: '监测社交媒体舆情',
        gatherInsights: '收集客户洞察',
        modelOpportunities: '建模与验证市场机会',
        developPersonas: '构建用户画像',
      },
    },
    marketingStrategy: {
      title: '营销策略',
      items: {
        defineObjectives: '制定营销目标',
        developMessages: '制定核心信息',
        developOmnichannel: '设计全渠道策略',
        designBudget: '制定预算分配方案',
        designMetrics: '设定绩效指标',
      },
    },
    contentCreation: {
      title: '内容创作',
      items: {
        developViralIdeas: '构思病毒式创意',
        createSocialPosts: '创建社交媒体帖子',
        createSeoBlogs: '撰写 SEO 博客',
        writeWebsiteContent: '撰写网站文案与 UX 文案',
        generateImages: '生成营销图片',
        generateVideos: '生成营销视频',
        generateVideoAds: '生成视频广告',
        generateEmails: '生成营销邮件',
      },
    },
    digitalMarketing: {
      title: '数字营销',
      items: {
        generateSeoBlogs: '生成并发布 SEO 博客',
        generateSocialPosts: '生成并发布社交媒体帖子',
        collaborateInfluencers: '与 KOL 合作',
        discoverLookalike: '发现相似 KOL',
        vetInfluencers: '根据要求筛选 KOL',
        collaborateAffiliates: '与联盟伙伴合作推动销售',
        findCustomers: '寻找潜在客户',
        generatePrLeads: '生成公关媒体线索',
        leveragePaidAds: '投放付费广告放大效果',
      },
    },
    offlineEvents: {
      title: '线下活动',
      items: {
        planEvents: '策划线下活动',
      },
    },
    brandManagement: {
      title: '品牌管理',
      items: {
        developBrandImage: '打造品牌形象',
        developBrandVoice: '制定品牌语调',
      },
    },
  },

  // 分享模板
  shareTemplate: {
    title: '看看 Aha 能为你实现什么',
  },

  // 使用详情弹窗
  creditsDetailsModal: {
    title: '使用情况',
    columns: {
      date: '日期',
      details: '详情',
      taskChange: '任务变更',
    },
    plan: '套餐',
    buttons: {
      manage: '管理',
      upgrade: '升级',
    },
    labels: {
      tasks: '任务',
      dailyFreeTasks: '每日免费任务',
    },
  },

  // 删除任务弹窗
  deleteModal: {
    title: '删除任务？',
    description: '确定要删除此任务吗？此操作无法撤销。',
    buttons: {
      delete: '删除',
    },
    messages: {
      deleted: '任务已删除。',
      failed: '删除任务失败。',
    },
    content: '确定要删除此任务吗？此操作无法撤销。',
  },

  // 活动推荐
  campaignRecommendation: {
    title: '让策略立即落地！',
    subtitle: '点击“创建活动”即可立即见效。',
    createCampaign: '创建活动',
    loading: '加载中...',
    errors: {
      missingFields: '缺少必填字段',
      createFailed: '创建活动失败',
    },
  },

  // 等待用户输入
  needUserInput: {
    message: '收到您的回复后，Head 将继续执行任务...',
  },

  // 反馈弹窗
  feedbackModal: {
    title: '反馈',
    submit: '提交',
    feedbackOptions: {
      misunderstanding: '理解有误',
      inaccurate: '不够准确',
      irrelevant: '不相关',
      tooGeneral: '过于笼统',
      others: '其他',
    },
    placeholder: '（可选）请分享任何意见或建议，帮助我们改进。非常感谢！',
  },

  // 功能调用工具
  functionCallTools: {
    headDnaRetrieved: 'Aha 的 DNA 与长期记忆已加载',
    thinking: '思考中...',
    taskCompleted: '任务已完成！',
    mustUseType: '必须使用的类型',
    unknownTools: '未知工具',
  },

  // 重命名弹窗
  renameModal: {
    title: '重命名任务',
    save: '保存',
    placeholder: '输入新的任务名称',
    errors: {
      emptyName: '会话名称不能为空',
      renameFailed: '任务重命名失败。',
    },
    success: '任务已重命名。',
  },

  // 底部区域
  sideBottom: {
    share: {
      title: '邀请好友使用 Aha',
      subtitle: '推荐好友，即可获得 4 个任务',
    },
    plan: {
      title: '套餐',
      tasks: '任务',
      manage: '管理',
      upgrade: '升级',
    },
  },

  // 等候名单分享弹窗
  waitListShareModal: {
    title: '邀请好友使用 Aha',
    subtitle: '推荐 2 位好友即可获得',
    adCredits: '广告额度',
    invitationCode: '邀请码',
    friendsInvited: '已邀请好友',
    share: '分享',
    tooltip: '认识 Head，全球首个 AI 营销员。',
    placeholder: '请输入被邀请人邮箱',
    send: '发送',
    invitationSent: '邀请已成功发送',
    enterValidEmail: '请输入有效的邮箱地址',
  },
};
